import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { gamesApi } from '../api/games'

export default function JoinGame() {
    const { code } = useParams()
    const navigate  = useNavigate()
    const [error, setError] = React.useState(null)

    React.useEffect(() => {
        gamesApi.joinByCode(code)
            .then(game => navigate(`/game/${game.id}/setup`, { replace: true }))
            .catch(err => setError(err.message))
    }, [code]) // eslint-disable-line react-hooks/exhaustive-deps

    if (error) {
        return (
            <main className="flex min-h-screen w-full flex-col items-center justify-center gap-4 bg-bankroll-teal px-6">
                <p className="text-white font-bold text-lg">{error}</p>
                <button
                    className="px-5 py-2.5 bg-bankroll-primary text-white border-0 rounded-md font-karla font-bold cursor-pointer hover:opacity-90"
                    onClick={() => navigate('/lobby', { replace: true })}
                >
                    Go to Lobby
                </button>
            </main>
        )
    }

    return (
        <main className="flex min-h-screen w-full items-center justify-center bg-bankroll-teal">
            <p className="text-gray-100">Joining game…</p>
        </main>
    )
}
